import {
  Box,
  Pagination,
  Stack,
  CircularProgress,
  Alert,
  TextField,
  MenuItem,
  Typography,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import ProductCard from "./productCard";
import { useTranslation } from "react-i18next";
import { PRODUCTS_LIST } from "../../../locales/pages/namespaces";

const ProductsGrid = ({
  products = [],
  totalPages = 0,
  currentPage = 1,
  loading = false,
  error = null,
  onPageChange = () => {},
  onSortChange = () => {},
  onAddToCart = () => {},
  sortValue = "default",
  totalResults = 0,
}) => {
  const history = useHistory();
  const { t } = useTranslation(PRODUCTS_LIST);

  const handleProductClick = (id) => {
    history.push(`/product/${id}`);
  };

  const sortedProducts = products;

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error">
        {error.message || t("Failed to load products")}
      </Alert>
    );
  }

  if (products.length === 0) {
    return (
      <Stack spacing={1} sx={{ alignItems: "center", py: 4 }}>
        <Alert severity="info" sx={{ width: "100%" }}>
          {t("No products found")}
        </Alert>
        <Typography variant="body2" sx={{ color: "#8D8D8D" }}>
          {t("Try adjusting your filters")}
        </Typography>
      </Stack>
    );
  }

    const sortMenuItems = [
        { id: "default", description: t("Sort by").toUpperCase(), disabled: true },
        { id: "1", description: t("Price ascending") },
        { id: "2", description: t("Price descending") },
        { id: "3", description: t("Newest") },
        { id: "4", description: t("Best Sellers") },
    ];

  return (
    <Stack spacing={3}>
      {/* Controls Row - Count | Sort */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 1,
          pb: 2,
          flexWrap: "wrap",
        }}
      >
        {/* Left: Results Count */}
        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexShrink: 0,
          }}
        >
          <Typography sx={{ color: "#8D8D8D", fontSize: 14, fontWeight: 900 }}>
            {products.length}
          </Typography>
          <Typography sx={{ color: "#8D8D8D", fontSize: 14, fontWeight: 900 }}>
            {t("Products").toUpperCase()}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{ width: 1, height: 20, borderRight: "1px solid #ddd", mx: 1 }}
          />
          <TextField
            select
            size="small"
            value={sortValue}
            onChange={(e) => onSortChange(e.target.value)}
            variant="standard"
            sx={{
              bgcolor: "#ffffffff",
              textAlign: "center",
              minWidth: 180,
              "& .MuiInput-root": {
                fontSize: 14,
                fontWeight: 500,
              },
              "& .MuiInput-underline:before": {
                borderBottom: "none !important",
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottom: "none !important",
              },
              "& .MuiInput-underline:after": {
                borderBottom: "2px solid #E5007E",
              },
            }}
          >
              {sortMenuItems.map((item) => (
                  <MenuItem key={item.id} value={item.id} disabled={item.disabled}>
                      {item.description}
                  </MenuItem>
              ))}
          </TextField>
        </Box>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(1, 1fr)",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
            lg: "repeat(4, 1fr)",
          },
          gap: 3,
        }}
      >
        {sortedProducts.map((product) => (
          <Box
            key={product.id}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ProductCard
                isFromList={true}
              product={product}
              onClick={() => handleProductClick(product.id)}
              onAddToCart={(e) => {
                e.stopPropagation();
                onAddToCart(product);
              }}
            />
          </Box>
        ))}
      </Box>

      {totalPages > 1 && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(e, page) => onPageChange(page)}
            color="primary"
            size="medium"
            siblingCount={0}
            boundaryCount={1}
            sx={{
              "& .MuiPagination-ul": { gap: "8px" },
              "& .MuiPaginationItem-root": {
                // borderRadius: 1,
                width: 40,
                height: 40,
                fontFamily: "Zen Maru Gothic",
                fontWeight: 900,
                fontSize: 14,
                lineHeight: "120%",
                bgcolor: "#fff",
                borderRadius: 20,
                color: "#111",
                transition: "0.2s",
                "&.Mui-selected": {
                  backgroundColor: "#E5007E",
                  borderColor: "#E5007E",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#E5007E",
                  },
                },
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              },
            }}
          />
        </Box>
      )}
    </Stack>
  );
};

export default ProductsGrid;
